import type { Season, SeasonId } from '@features/seasonal-theme/types';

import { SEASONS } from '@features/seasonal-theme/utils/seasons';
import { isWithin } from '@features/seasonal-theme/utils/season-dates';

export const findSeason = (id: string | null): Season | undefined => SEASONS.find((season) => season.id === id);

export const resolveSeason = (date: Date, seasons: Season[] = SEASONS): Season | null =>
  seasons.find((season) => isWithin(date, season.range(date.getFullYear()))) ?? null;

export const isSeasonId = (value: string): value is SeasonId => SEASONS.some((season) => season.id === value);
